import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICreateGroupResponse, IGroupState, IGroup } from "../../common/types/groupTypes";
import { editGroupUrl } from "../../config";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";

const EDIT_GROUP: string = "editGroup"

const initialState: IGroupState = {
  groups: [],
  status: Status.IDLE,
  error: null,
  reqId: null,
  msg: null,
  orgId: null,
  parentHierarchy: null
};


export const editGroup = createAsyncThunk(EDIT_GROUP, async (payload: IGroup, { rejectWithValue }) => {
    try {
      const response = await api.patch<ICreateGroupResponse>(editGroupUrl, payload);
      const editGroupResponse: ICreateGroupResponse = response.data;
      return editGroupResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const editGroupSlice = createSlice({
  name: EDIT_GROUP,
  initialState,
  reducers: { setEditGroupData: (state: IGroupState, action) => {
    if(action.payload) {
      state.orgId = action.payload.orgId;
      state.parentHierarchy = action.payload.parentHierarchy;
    } else {
      state.orgId = initialState.orgId;
      state.parentHierarchy = initialState.parentHierarchy;
    }
  }},
  extraReducers: (builder) => {
    builder
      .addCase(editGroup.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(editGroup.fulfilled, (state, action) => {
        state.groups = [...state.groups, action.payload.data];
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(editGroup.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random()
        state.status = Status.FAILED;
      });
  },
});


export const { setEditGroupData } = editGroupSlice.actions;
export const selector = (state: RootState) => state.editGroup;
export default editGroupSlice.reducer;
